import { useState } from 'react';
import { LeadStatusSelector } from '../../../scenes/leads/status/LeadStatusSelector';
import LabeledBox from '../../special/LabeledBox';
import { Status } from '../../special/Status';
import { useTranslation } from 'react-i18next';
import { Box, Button, useTheme } from '@mui/material';
import { tokens } from '../../../global/theme/tokens';
import ClearIcon from '@mui/icons-material/Clear';

export const TypeLeadStatus = ({
  field,
  dataCollection,
  errors = {},
  updateValidationOnChange,
  size,
  onFocus,
  onBlur,
}) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode, theme.palette.colorTheme);
  const { t } = useTranslation();

  const [anchorEl, setAnchorEl] = useState(null);
  const handleClick = (event, item) => {
    setAnchorEl(anchorEl ? null : event.currentTarget);
  };

  function handleStatusChange(status) {
    updateValidationOnChange([field.key], status);
  }

  const handleReset = () => {
    updateValidationOnChange(field.key, null);
  };

  const { label, variant, color } = dataCollection[field.key] || {};

  return (
    <Box className="flex w-full gap-2">
      <LabeledBox
        onClick={handleClick}
        label={field.label}
        className="w-full"
        size={size}
        sx={{
          padding:
            size === 'small' ? '8.5px 14px!important' : '11px 14px!important',
        }}
      >
        {dataCollection[field.key] && (
          <Status
            text={label || t('No Status')}
            variant={variant || 'base'}
            statusColor={color}
          />
        )}
      </LabeledBox>
      {dataCollection[field.key] && (
        <Button
          onClick={handleReset}
          sx={{
            minWidth: 'unset',
            bgcolor: colors.bgInput,
            aspectRatio: '1/1',
            width: size === 'small' ? '40px' : '53px',
            height: size === 'small' ? '40px' : '53px',
            borderRadius: '10px',
            border: `1px solid transparent`,
            ':hover': {
              bgcolor: colors.error + '30',
              border: `1px solid ${colors.error}80`,
              color: colors.error,
            },
          }}
        >
          <ClearIcon />
        </Button>
      )}
      <LeadStatusSelector
        anchorEl={anchorEl}
        onClose={() => setAnchorEl(null)}
        onStatusChange={(status) => handleStatusChange(status)}
        hiddenStatuses={[dataCollection[field.key]]}
      />
    </Box>
  );
};
